/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";

export type GetGameSteamSummaryRequest = {
  steamid?: string | undefined;
  id?: string | undefined;
  id3?: string | undefined;
  key?: string | undefined;
};

export const GetGameSteamSummaryRequest$zodSchema: z.ZodType<
  GetGameSteamSummaryRequest
> = z.object({
  id: z.string().describe(
    "用户的 Steam 自定义URL名称（Vanity URL）。例如个人资料链接中 `/id/` 后面的部分。",
  ).optional(),
  id3: z.string().describe(
    "用户的 Steam ID3 格式标识符。传统的 Steam ID 格式，形如 STEAM_X:Y:Z。",
  ).optional(),
  key: z.string().describe(
    "你的 Steam Web API Key。这是一个可选参数，如果提供，它将覆盖我们在后端配置的全局Key。这为你提供了更大的灵活性，但请务必注意Key的保密，不要在前端暴露。",
  ).optional(),
  steamid: z.string().describe(
    "用户的 Steam 标识。可以是以下任意一种格式：\n- 纯数字的 **SteamID64**\n- 用户的 **自定义 URL 名称** (Vanity URL)\n- 完整的 **个人资料链接** (包含 SteamID64 或自定义名称)\n- 好友代码 (如 `22202`)",
  ).optional(),
});

export type GetGameSteamSummaryBadGatewayDetails = {};

export const GetGameSteamSummaryBadGatewayDetails$zodSchema: z.ZodType<
  GetGameSteamSummaryBadGatewayDetails
> = z.object({});

/**
 * 上游服务错误。在向 Steam 的官方 API 请求数据时遇到了问题。这可能是他们的服务暂时中断，请稍后重试。
 */
export type GetGameSteamSummaryBadGatewayResponseBody = {
  code?: string | undefined;
  details?: GetGameSteamSummaryBadGatewayDetails | undefined;
  message?: string | undefined;
};

export const GetGameSteamSummaryBadGatewayResponseBody$zodSchema: z.ZodType<
  GetGameSteamSummaryBadGatewayResponseBody
> = z.object({
  code: z.string().optional(),
  details: z.lazy(() => GetGameSteamSummaryBadGatewayDetails$zodSchema)
    .optional(),
  message: z.string().optional(),
}).describe(
  "上游服务错误。在向 Steam 的官方 API 请求数据时遇到了问题。这可能是他们的服务暂时中断，请稍后重试。",
);

export type GetGameSteamSummaryNotFoundDetails = {};

export const GetGameSteamSummaryNotFoundDetails$zodSchema: z.ZodType<
  GetGameSteamSummaryNotFoundDetails
> = z.object({});

/**
 * 用户未找到。根据你提供的 SteamID 未能找到对应的用户，或者该用户资料为完全私密。
 */
export type GetGameSteamSummaryNotFoundResponseBody = {
  code?: string | undefined;
  details?: GetGameSteamSummaryNotFoundDetails | undefined;
  message?: string | undefined;
};

export const GetGameSteamSummaryNotFoundResponseBody$zodSchema: z.ZodType<
  GetGameSteamSummaryNotFoundResponseBody
> = z.object({
  code: z.string().optional(),
  details: z.lazy(() => GetGameSteamSummaryNotFoundDetails$zodSchema)
    .optional(),
  message: z.string().optional(),
}).describe(
  "用户未找到。根据你提供的 SteamID 未能找到对应的用户，或者该用户资料为完全私密。",
);

export type GetGameSteamSummaryUnauthorizedDetails = {};

export const GetGameSteamSummaryUnauthorizedDetails$zodSchema: z.ZodType<
  GetGameSteamSummaryUnauthorizedDetails
> = z.object({});

/**
 * 认证失败。你提供的 Steam Web API Key 无效或已过期，或者你没有提供 Key。请检查你的 Key。
 */
export type GetGameSteamSummaryUnauthorizedResponseBody = {
  code?: string | undefined;
  details?: GetGameSteamSummaryUnauthorizedDetails | undefined;
  message?: string | undefined;
};

export const GetGameSteamSummaryUnauthorizedResponseBody$zodSchema: z.ZodType<
  GetGameSteamSummaryUnauthorizedResponseBody
> = z.object({
  code: z.string().optional(),
  details: z.lazy(() => GetGameSteamSummaryUnauthorizedDetails$zodSchema)
    .optional(),
  message: z.string().optional(),
}).describe(
  "认证失败。你提供的 Steam Web API Key 无效或已过期，或者你没有提供 Key。请检查你的 Key。",
);

export type GetGameSteamSummaryBadRequestDetails = {};

export const GetGameSteamSummaryBadRequestDetails$zodSchema: z.ZodType<
  GetGameSteamSummaryBadRequestDetails
> = z.object({});

/**
 * 请求失败。请检查你是否提供了 `steamid`、`id` 或 `id3` 中的任意一个参数。
 */
export type GetGameSteamSummaryBadRequestResponseBody = {
  code?: string | undefined;
  details?: GetGameSteamSummaryBadRequestDetails | undefined;
  message?: string | undefined;
};

export const GetGameSteamSummaryBadRequestResponseBody$zodSchema: z.ZodType<
  GetGameSteamSummaryBadRequestResponseBody
> = z.object({
  code: z.string().optional(),
  details: z.lazy(() => GetGameSteamSummaryBadRequestDetails$zodSchema)
    .optional(),
  message: z.string().optional(),
}).describe(
  "请求失败。请检查你是否提供了 `steamid`、`id` 或 `id3` 中的任意一个参数。",
);

/**
 * 查询成功！返回用户的 Steam 公开资料摘要。
 */
export type GetGameSteamSummaryResponseBody = {
  avatar?: string | undefined;
  avatarfull?: string | undefined;
  avatarmedium?: string | undefined;
  communityvisibilitystate?: number | undefined;
  loccountrycode?: string | undefined;
  personaname?: string | undefined;
  personastate?: number | undefined;
  primaryclanid?: string | undefined;
  profilestate?: number | undefined;
  profileurl?: string | undefined;
  realname?: string | undefined;
  steamid?: string | undefined;
  timecreated?: number | undefined;
  timecreated_str?: string | undefined;
};

export const GetGameSteamSummaryResponseBody$zodSchema: z.ZodType<
  GetGameSteamSummaryResponseBody
> = z.object({
  avatar: z.string().optional(),
  avatarfull: z.string().optional(),
  avatarmedium: z.string().optional(),
  communityvisibilitystate: z.int().optional(),
  loccountrycode: z.string().optional(),
  personaname: z.string().optional(),
  personastate: z.int().optional(),
  primaryclanid: z.string().optional(),
  profilestate: z.int().optional(),
  profileurl: z.string().optional(),
  realname: z.string().optional(),
  steamid: z.string().optional(),
  timecreated: z.int().optional(),
  timecreated_str: z.string().optional(),
}).describe("查询成功！返回用户的 Steam 公开资料摘要。");

export type GetGameSteamSummaryResponse =
  | GetGameSteamSummaryResponseBody
  | GetGameSteamSummaryBadRequestResponseBody
  | GetGameSteamSummaryUnauthorizedResponseBody
  | GetGameSteamSummaryNotFoundResponseBody
  | GetGameSteamSummaryBadGatewayResponseBody;

export const GetGameSteamSummaryResponse$zodSchema: z.ZodType<
  GetGameSteamSummaryResponse
> = z.union([
  z.lazy(() => GetGameSteamSummaryResponseBody$zodSchema),
  z.lazy(() => GetGameSteamSummaryBadRequestResponseBody$zodSchema),
  z.lazy(() => GetGameSteamSummaryUnauthorizedResponseBody$zodSchema),
  z.lazy(() => GetGameSteamSummaryNotFoundResponseBody$zodSchema),
  z.lazy(() => GetGameSteamSummaryBadGatewayResponseBody$zodSchema),
]);
